import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [productsOpen, setProductsOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setProductsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close dropdown on route change
  useEffect(() => {
    setProductsOpen(false);
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === "/";

  return (
    <header className="bg-[#163248] text-white border-b border-white/10 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">

        {/* Logo */}
        <Link to="/" className="flex items-center gap-3">
          <img
            src="/M3_Global medicare llp.png"
            alt="Mohan Mutha International LLP"
            className="h-20 md:h-24 w-auto object-contain"
          />
          <div>
            <p className="text-sm font-semibold tracking-wide">Mohan Mutha International LLP</p>
            <p className="text-xs text-slate-300">Healthcare Services & Medical Solutions</p>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-6 text-sm text-slate-200">
          {isHome ? (
            <>
              <a href="#home" className="hover:text-[#6ec87a] transition-colors">Home</a>
              <a href="#about" className="hover:text-[#6ec87a] transition-colors">About</a>
              <a href="#services" className="hover:text-[#6ec87a] transition-colors">Services</a>
              <a href="#why-us" className="hover:text-[#6ec87a] transition-colors">Why Us</a>
            </>
          ) : (
            <>
              <Link to="/" className="hover:text-[#6ec87a] transition-colors">Home</Link>
              <Link to="/#about" className="hover:text-[#6ec87a] transition-colors">About</Link>
              <Link to="/#services" className="hover:text-[#6ec87a] transition-colors">Services</Link>
              <Link to="/#why-us" className="hover:text-[#6ec87a] transition-colors">Why Us</Link>
            </>
          )}

          {/* Products Dropdown */}
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setProductsOpen((p) => !p)}
              className="flex items-center gap-1 hover:text-[#6ec87a] transition-colors focus:outline-none"
            >
              Products
              <svg
                className={`w-4 h-4 transition-transform duration-200 ${productsOpen ? "rotate-180" : ""}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {productsOpen && (
              <div className="absolute top-full left-1/2 -translate-x-1/2 mt-3 w-36 bg-[#0f2236] border border-white/10 rounded-xl shadow-2xl overflow-hidden z-50">
                <Link
                  to="/paus"
                  className="block px-5 py-3 text-sm font-semibold text-white hover:bg-white/10 transition-colors border-b border-white/10"
                >
                  PAUS
                </Link>
                <Link
                  to="/ilo"
                  className="block px-5 py-3 text-sm font-semibold text-white hover:bg-white/10 transition-colors"
                >
                  ILO
                </Link>
              </div>
            )}
          </div>

          {isHome ? (
            <a href="#contact" className="hover:text-[#6ec87a] transition-colors">Contact</a>
          ) : (
            <Link to="/#contact" className="hover:text-[#6ec87a] transition-colors">Contact</Link>
          )}
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden text-white focus:outline-none"
          onClick={() => setMobileOpen((p) => !p)}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {mobileOpen
              ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            }
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-[#0f2236] border-t border-white/10 px-6 py-4 flex flex-col gap-4 text-sm text-slate-200">
          {isHome ? (
            <>
              <a href="#home" className="hover:text-[#6ec87a]">Home</a>
              <a href="#about" className="hover:text-[#6ec87a]">About</a>
              <a href="#services" className="hover:text-[#6ec87a]">Services</a>
              <a href="#why-us" className="hover:text-[#6ec87a]">Why Us</a>
              <a href="#contact" className="hover:text-[#6ec87a]">Contact</a>
            </>
          ) : (
            <>
              <Link to="/" className="hover:text-[#6ec87a]">Home</Link>
              <Link to="/#about" className="hover:text-[#6ec87a]">About</Link>
              <Link to="/#services" className="hover:text-[#6ec87a]">Services</Link>
              <Link to="/#why-us" className="hover:text-[#6ec87a]">Why Us</Link>
              <Link to="/#contact" className="hover:text-[#6ec87a]">Contact</Link>
            </>
          )}
          <p className="text-xs text-slate-400 uppercase tracking-widest pt-2">Products</p>
          <Link to="/paus" className="flex items-center gap-2 hover:text-[#6ec87a]">
            <img src="/PAUS Logo_White.png" alt="PAUS" className="h-6 w-auto object-contain" />
            PAUS
          </Link>
          <Link to="/ilo" className="flex items-center gap-2 hover:text-[#6ec87a]">
            <img src="/White ilo.jpg" alt="ILO" className="h-6 w-auto object-contain rounded" />
            ILO
          </Link>
        </div>
      )}
    </header>
  );
}